const STORAGE_KEY = "gu.logger";
export { STORAGE_KEY };
